/**
 * Los textos de los errores de una lectura de la ficha (diseño 4a §6, textos 46 a 52, aprobados por Bernardo el 2026-10-04; el de
 * `contraparte_no_encontrada`, también el 2026-10-04), más los cuatro generales que también puede dar esa lectura (sesión vencida,
 * argumentos no válidos, red y error del servidor). Corte 4c: un solo lugar para Argus Team (api/errors.ts, el respaldo de cuando el
 * servidor no manda mensaje) y Nexo (ficha/mensajes.ts), que antes los tomaba del archivo de Argus Team.
 *
 * El backend de Argus Team (argus-team-web/server/src/errors.ts) manda los mismos textos con su código; no importa app/shared al
 * correr (el paquete del VPS no lo lleva), así que conserva los suyos. La prueba `errores del servidor y de la ficha` de
 * app/scripts/nexo-ficha.test.ts compara las dos listas.
 */
export const MENSAJES_FICHA = {
  // 46 a 52 y el de la contraparte.
  run_changed: 'El Registro Público de Comercio se actualizó después de tu búsqueda. Busca de nuevo.',
  ficha_no_encontrada: 'Ya no encontramos a esta persona o empresa. Busca de nuevo.',
  contraparte_no_encontrada: 'Ya no encontramos a la persona o empresa con que se relaciona. Busca de nuevo.',
  evidencia_corrida_cambio: 'La fuente cambió porque el Registro Público de Comercio se actualizó. Busca de nuevo.',
  evidencia_no_encontrada: 'No encontramos esa parte del documento.',
  nexo_timeout: 'La consulta tardó demasiado. Intenta de nuevo.',
  respuesta_muy_grande: 'Esta ficha es demasiado grande para mostrarla. Avisa a un administrador.',
  ficha_sin_frase: 'No pudimos leer esta ficha.',
  // Los generales que también puede dar la lectura de una ficha.
  unauthorized: 'Tu sesión terminó. Vuelve a cargar la página para iniciar sesión.',
  invalid_request: 'Revisa lo que escribiste; algo no tiene el formato esperado.',
  network: 'No pudimos comunicarnos con Argus. Revisa tu internet e inténtalo de nuevo.',
  server_error: 'Argus tuvo un problema. Inténtalo de nuevo en un momento.',
} as const;
export type CodigoFicha = keyof typeof MENSAJES_FICHA;
